const getLanguageForm = (i18n) => {
  let lang = ''
  switch (i18n.language) {
    case 'zh':
      lang = '151ba38c0269'
      break
    case 'zh-hans':
      lang = 'b74e6cd102e1'
      break
    default:
      lang = '45c3add7853e'
  }
  return lang
}
export default getLanguageForm
